import { createContext, } from 'react';
import { FilterPaymentsContextType, } from './PaymentFilterTypes';

export const PaymentsFilterContext = createContext<FilterPaymentsContextType | null>(null);